import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router';
import { Hammer, HardHat, KeyRound } from 'lucide-react';

const BannerImgTuraq = new URL(
  '../../assetts/images/turaqbanner.webp',
  import.meta.url,
).href;
// Phones show the banner ~360 px wide: a 800 px copy is enough there.
const BannerImgTuraq800 = new URL(
  '../../assetts/images/turaqbanner-800.webp',
  import.meta.url,
).href;

const BannerTuraqKg: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section className="w-full">
      <div className="relative container mx-auto px-4 py-10 md:py-16 w-full">
        <div className="relative overflow-hidden rounded-3xl bg-white p-6 md:p-10 flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Decorative texture behind the text only — background stays
              white; just a faint dot-grid + a small cluster of
              real-estate/construction icons (key, hard hat, hammer), so
              this half of the card reads as "недвижимость" without adding
              any color wash. */}
          <div
            className="pointer-events-none absolute left-0 top-0 h-full w-full md:w-[55%] opacity-[0.6]"
            style={{
              backgroundImage:
                'radial-gradient(circle, rgba(37,99,235,0.35) 1px, transparent 1.5px)',
              backgroundSize: '18px 18px',
              maskImage: 'radial-gradient(ellipse at 20% 30%, black, transparent 70%)',
              WebkitMaskImage: 'radial-gradient(ellipse at 20% 30%, black, transparent 70%)',
            }}
          />
          <KeyRound
            className="pointer-events-none absolute left-[6%] top-[12%] hidden h-20 w-20 rotate-12 text-blue-600/20 sm:block"
            strokeWidth={1.3}
          />
          <HardHat
            className="pointer-events-none absolute left-[30%] bottom-[10%] hidden h-16 w-16 -rotate-6 text-indigo-600/[0.18] md:block"
            strokeWidth={1.3}
          />
          <Hammer
            className="pointer-events-none absolute left-[2%] bottom-[8%] hidden h-14 w-14 rotate-[20deg] text-blue-600/[0.15] lg:block"
            strokeWidth={1.3}
          />

          {/* TEXT */}
          <div className="max-w-xl z-10 order-2 md:order-1 text-center md:text-left">
            <h2 className="text-2xl md:text-4xl font-bold text-gray-900 leading-snug">
              {t('banner.title', { highlight: 'TuraqKg' })}
            </h2>

            <p className="mt-4 text-gray-600 text-base md:text-lg">
              {t('banner.description')}
            </p>

            <Link
              to="/create-listing"
              className="text-blue-600 hover:text-blue-700 flex items-center gap-2 transition-colors"
            >
              <button className="mt-6 px-6 py-3 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl shadow-md transition-all duration-200 mx-auto md:mx-0 cursor-pointer">
                {t('banner.button')}
              </button>
            </Link>
          </div>

          {/* IMAGE */}
          <div className="relative w-full lg:w-[55%] h-[260px] md:h-[340px] lg:h-[420px] xl:h-[480px] flex items-center justify-center order-1 md:order-2">
            <img
              src={BannerImgTuraq}
              srcSet={`${BannerImgTuraq800} 800w, ${BannerImgTuraq} 1600w`}
              sizes="(max-width: 1024px) 100vw, 55vw"
              alt="TuraqKg Banner"
              width={1600}
              height={1062}
              loading="lazy"
              decoding="async"
              className="object-contain lg:object-cover"
            />
          </div>

          {/* DECOR */}
        </div>
      </div>
    </section>
  );
};

export default BannerTuraqKg;
